export default __webpack_public_path__ + "static/media/Animals-07.c0a0d7e3.png";